import { HEALTH, type Health } from './tokens'

interface Props {
  health: string
  showLabel?: boolean
  className?: string
}

export function HealthIndicator({ health, showLabel = true, className = '' }: Props) {
  const key = (health?.toLowerCase().replace(' ', '_') ?? 'on_track') as Health
  const token = HEALTH[key] ?? HEALTH.on_track
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      aria-label={`Health: ${token.label}`}
    >
      <span className={`w-2 h-2 rounded-full flex-shrink-0 ${token.dot}`} aria-hidden="true" />
      {showLabel && (
        <span className={`text-xs font-medium px-1.5 py-0.5 rounded border ${token.badge}`}>
          {token.label}
        </span>
      )}
    </span>
  )
}
